"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBody = exports.ContentContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.ContentContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin: ", ";\n  padding: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin: ", ";\n  padding: ", ";\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxlarge;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxlarge;
}, (0, storm_ui_1.isMobileStyleMixin)((0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "])))));
exports.CardBody = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", ";\n  ", "\n"], ["\n  margin: ", ";\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.medium;
}, (0, storm_ui_1.isMobileStyleMixin)((0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-inline-start: 0;\n  "], ["\n    margin-inline-start: 0;\n  "])))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
